module.exports = __webpack_public_path__ + "img/lighting.c6c10e67.jpeg";